import { CloudCustomerType } from "@omni/types/api/customer/cloud/shared/enums/customerType.enum";
import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";

export const $CustomerModuleName = "customer";

export type TCustomerState = ComponentsCustomer;

export type SubscriptionRequest = {
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    storeId: string;
};

export type UpdateCustomerRequest = {
    customerType: CloudCustomerType;
    firstName: string;
    lastName: string;
    companyName?: string | null;
    vatNr?: string | null;
    phone?: string | null;
    dateOfBirth?: string | null;
    favouriteStoreId?: string | null;
    receiveSms: boolean;
    language: string;
    bonusCardNumber?: string | null;
    requestInvoice: boolean;
    newsLetterSubscribed: boolean;
};
